import * as Assert from 'assert'
import React from 'react'

import { UserDto } from '../utils/types'

interface AppContextProps {
    user: UserDto | undefined
    setUser(user: UserDto | undefined): void
}

export const AppContext = React.createContext<AppContextProps|undefined>(undefined)
export const useAppContext = () => {
    const k = React.useContext(AppContext)
    Assert.ok(k)

    return k
}
